<template>
  <!-- 季度选择时间控件 -->
  <div class="year-picker">
    <el-date-picker
      v-model="beginTime"
      type="year"
      align="right"
      value-format="yyyy"
      :picker-options="pickerOptionsYearEnd"
       :clearable="false"
      style="width: 110px;"
      @change="changeTime"
      :placeholder="$t('yearRangePicker.kai_shi_nian')"
    ></el-date-picker>
    <span class="bar">-</span>
    <el-date-picker
      v-model="endTime"
      type="year"
      align="right"
      value-format="yyyy"
      :picker-options="pickerOptionsYear"
       :clearable="false"
      style="width: 110px;"
      @change="changeTime"
      :placeholder="$t('yearRangePicker.jie_shu_nian')"
    ></el-date-picker>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 * @api: valueArr : 季度value defalut['01-03', '04-06', '07-09', '10-12'] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
export default {
  name: 'YearRangpicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    unbindOrgTime: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      beginTime: this.value[0],
      endTime: this.value[1],
      pickerOptionsYearEnd: {
        disabledDate: time => time.getFullYear() > this.endTime || time.getFullYear() > new Date().getFullYear() || time.getFullYear() < 2016 // 注意是 || 不是 && 哦
      },
      pickerOptionsYear: {
        disabledDate: time => time.getFullYear() > new Date().getFullYear() || time.getFullYear() < 2016// 注意是 || 不是 && 哦
      },
      year: new Date().getFullYear()
    };
  },

  mounted() {
    this.beginTime = this.value[0];
    this.endTime = this.value[1];
  },
  watch: {
    value: function (val) {
      this.beginTime = val[0];
      this.endTime = val[1];
    },
    unbindOrgTime: {
      immediate: true,
      handler(val) {
        if (val) {
          // 已到期设备用已到期的时候
          this.pickerOptionsYearEnd = {
            disabledDate: time => time.getFullYear() > this.endTime - 1 || time.getFullYear() < 2016 // 注意是 || 不是 && 哦
          };
          this.pickerOptionsYear = {
            disabledDate: time => time.getFullYear() < 2016 // 注意是 || 不是 && 哦
          };
        }
      },
    },
  },
  methods: {
    selectSeason(i) {
      const that = this;
      that.season = i + 1;
      const arr = that.valueArr[i];
      const seasonValue = that.getValue(`${that.year}-${arr}`);
      that.showSeason = false;
      this.showValue = this.$t('yearRangePicker.onianoji_du', [this.year,this.season]);
      that.$emit('chooseSeason', seasonValue); // 每次选择时间都将当前选择时间发送到父组件
      this.$emit('input', seasonValue);
      this.$emit('change', seasonValue);
    },

    changeTime() {
      // 补开头
      if (!this.beginTime && this.endTime) {
        this.beginTime = this.endTime;
      } else if (this.beginTime && !this.endTime) {
        // 补结束
        this.endTime = this.year;
      }
      if (this.endTime <= this.beginTime) {
        const maxTime = this.beginTime;
        this.beginTime = this.endTime;
        this.endTime = maxTime;
      }
      const Timer = [`${this.beginTime}`, `${this.endTime}`];
      this.$emit('input', Timer);
      this.$emit('change', Timer);
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.year-picker {
  font-size: 0px;
  line-height: 40px;
  .el-date-editor{
    transform: translateX(0px) !important;
  }
  .bar {
    font-size: 20px;
    line-height: 40px;
    margin: 0 3px;
    width: 20px;
    display: inline-block;
    text-align: center;
  }
  .el-input__inner {
    cursor: pointer;
    height: 40px;
    line-height: 41px;
    padding-left: 34px;
    font-weight: bold;
    color: $--color-text-primary;
  }
  .el-input__suffix {
    margin-right: 10px;
    color: #c0c4cc;
    width: 25px;
    // display: inline-block;
    float: right;
    line-height: 32px;
    .el-input__suffix-inner {
      width: 25px;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    .el-input__icon {
      width: 25px;
      height: 100%;
      display: inline;
      &:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
        display: inline;
        height: 100%;
      }
      &:before {
        display: inline;
        height: 100%;
      }
    }
  }
  .el-input__prefix {
    color: $--color-primary;
    font-size: 18px;
    margin-right: 8px;
    .icon {
      font-size: 18px;
    }
  }
}
</style>
